<template>
  <ColumnsBlock
    v-for="currentColumnBlock in maxColBlocks"
    :key="currentColumnBlock"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'content'
      })
    "
  >
    <template
      v-for="currentCol in columnWidth"
      :key="`${currentColumnBlock}_${currentCol}`"
      #[`col${currentCol}`]
    >
      <MappedComponent
        v-if="
          item.fields?.content?.[
            (currentColumnBlock - 1) * columnWidth + currentCol - 1
          ]
        "
        :item="
          item.fields?.content?.[
            (currentColumnBlock - 1) * columnWidth + currentCol - 1
          ]
        "
      />
    </template>
  </ColumnsBlock>
</template>

<script setup lang="ts">
import { ColumnsBlock } from '@hypercodestudio/basler-components';
import type { IColumns } from '~/lib/ContentfulService';
import { isDefined } from '~/utils/guards/isDefined';
import { ContentfulLivePreview } from '@contentful/live-preview';

interface Props {
  item: IColumns;
}

const props = defineProps<Props>();

const columnWidth = computed(() =>
  isDefined(props.item.fields.columns)
    ? parseInt(props.item.fields.columns.replace(' columns', ''))
    : 2
);

const maxColBlocks = computed(() =>
  props.item.fields?.content
    ? Math.ceil(props.item.fields.content.length / columnWidth.value)
    : 1
);
</script>
